<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #VatRateForm="ngForm" class="modal-form" novalidate>
    <div class="col-md-12 col-sm-12 p-0">
      <fieldset class="field-set">
        <legend>{{ "general" | translate }}</legend>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="VatGroupsCode" class="col-md-6 col-sm-12">
                <small
                  >{{ "code" | translate }} <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-6 col-sm-12">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  #VatGroupsCode="ngModel"
                  #focusElement
                  name="VatGroupsCode"
                  [disabled]="isReadOnly"
                  [ngClass]="
                    alertShow && VatGroupsCode.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.code"
                  id="VatGroupsCode"
                  maxlength="10"
                  required
                />
                <div
                  *ngIf="alertShow && VatGroupsCode.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-6 col-sm-12" for="VatGroupsName">
                <small
                  >{{ "description" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-6 col-sm-12">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  name="VatGroupsName"
                  #VatGroupsName="ngModel"
                  [disabled]="isReadOnly"
                  [ngClass]="
                    alertShow && VatGroupsName.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.description"
                  id="VatGroupsName"
                  maxlength="50"
                  required
                />
                <div
                  *ngIf="alertShow && VatGroupsName.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-md-12 col-sm-12 p-0">
      <fieldset class="field-set">
        <legend>{{ "vat_rate" | translate }}</legend>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="purch_vatrate" class="col-md-6 col-sm-12">
                <small>
                  {{ "purch_vat_rate" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-6 col-sm-12">
                <input
                  type="text"
                  id="purch_vatrate"
                  name="purch_vatrate"
                  class="form-control form-control-sm"
                  required
                  klNumberInput
                  maxLength="5"
                  #purch_vatrate="ngModel"
                  [disabled]="isReadOnly"
                  [ngClass]="
                    alertShow && purch_vatrate.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.purchase_vat_rate"
                />
                <div
                  *ngIf="alertShow && purch_vatrate.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="sales_vatrate" class="col-md-6 col-sm-12">
                <small
                  >{{ "sales_vat_rate" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-6 col-sm-12">
                <input
                  type="text"
                  maxlength="100"
                  name="sales_vatrate"
                  id="sales_vatrate"
                  #sales_vatrate="ngModel"
                  klNumberInput
                  maxLength="5"
                  [disabled]="isReadOnly"
                  [(ngModel)]="entity.sales_vat_rate"
                  [ngClass]="
                    alertShow && sales_vatrate.invalid ? 'errorInput' : ''
                  "
                  class="form-control form-control-sm"
                  aria-describedby="vatRate_name_help_text"
                  required
                />
                <div
                  *ngIf="alertShow && sales_vatrate.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="persale_vatrate" class="col-md-6 col-sm-12">
                <small>{{ "persale_vat_rate" | translate }}</small>
              </label>
              <div class="col-md-6 col-sm-12">
                <input
                  name="persale_vatrate"
                  id="persale_vatrate"
                  class="form-control form-control-sm"
                  klNumberInput
                  maxLength="5"
                  [disabled]="isReadOnly"
                  aria-describedby="vatRate_tax_office_help_text"
                  [(ngModel)]="entity.per_sales_vat_rate"
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </form>
</kl-form-container>
